import { Box } from '@mui/material';
import { FC } from 'react';
import Text from '../text';

interface Props {
  label: string;
}

export const DrawerFormSection: FC<Props> = ({ label }) => {
  return (
    <Box>
      <Text size="large" bold>
        {label}
      </Text>
    </Box>
  );
};
